import script from "./GradingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradingView.vue?vue&type=script&setup=true&lang=ts"

import "./GradingView.vue?vue&type=style&index=0&id=199b51fc&lang=css"
import "./GradingView.vue?vue&type=style&index=1&id=199b51fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199b51fc"]])

export default __exports__